/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type GetServerIdentityImpactSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetServerIdentityImpactSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetServerIdentityImpactSecurity = {
  option1?: GetServerIdentityImpactSecurityOption1 | undefined;
  option2?: GetServerIdentityImpactSecurityOption2 | undefined;
};

/**
 * The kind of binding change.
 */
export const Change = {
  Replace: "replace",
  Attach: "attach",
  Detach: "detach",
} as const;
/**
 * The kind of binding change.
 */
export type Change = ClosedEnum<typeof Change>;

export type GetServerIdentityImpactRequest = {
  /**
   * The user session issuer whose client bindings change.
   */
  userSessionIssuerId: string;
  /**
   * The MCP server the change is made from. Excluded from the result.
   */
  mcpServerId?: string | undefined;
  /**
   * The kind of binding change.
   */
  change: Change;
  /**
   * The Remote Identity Provider of the client being bound. Omit for a new provider.
   */
  providerId?: string | undefined;
  /**
   * An existing client being bound. Omit for a new client.
   */
  clientId?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetServerIdentityImpactSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetServerIdentityImpactSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetServerIdentityImpactSecurityOption1$Outbound,
    GetServerIdentityImpactSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getServerIdentityImpactSecurityOption1ToJSON(
  getServerIdentityImpactSecurityOption1:
    GetServerIdentityImpactSecurityOption1,
): string {
  return JSON.stringify(
    GetServerIdentityImpactSecurityOption1$outboundSchema.parse(
      getServerIdentityImpactSecurityOption1,
    ),
  );
}

/** @internal */
export type GetServerIdentityImpactSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetServerIdentityImpactSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetServerIdentityImpactSecurityOption2$Outbound,
    GetServerIdentityImpactSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getServerIdentityImpactSecurityOption2ToJSON(
  getServerIdentityImpactSecurityOption2:
    GetServerIdentityImpactSecurityOption2,
): string {
  return JSON.stringify(
    GetServerIdentityImpactSecurityOption2$outboundSchema.parse(
      getServerIdentityImpactSecurityOption2,
    ),
  );
}

/** @internal */
export type GetServerIdentityImpactSecurity$Outbound = {
  Option1?: GetServerIdentityImpactSecurityOption1$Outbound | undefined;
  Option2?: GetServerIdentityImpactSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetServerIdentityImpactSecurity$outboundSchema: z.ZodMiniType<
  GetServerIdentityImpactSecurity$Outbound,
  GetServerIdentityImpactSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetServerIdentityImpactSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetServerIdentityImpactSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getServerIdentityImpactSecurityToJSON(
  getServerIdentityImpactSecurity: GetServerIdentityImpactSecurity,
): string {
  return JSON.stringify(
    GetServerIdentityImpactSecurity$outboundSchema.parse(
      getServerIdentityImpactSecurity,
    ),
  );
}

/** @internal */
export const Change$outboundSchema: z.ZodMiniEnum<typeof Change> = z.enum(
  Change,
);

/** @internal */
export type GetServerIdentityImpactRequest$Outbound = {
  user_session_issuer_id: string;
  mcp_server_id?: string | undefined;
  change: string;
  provider_id?: string | undefined;
  client_id?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetServerIdentityImpactRequest$outboundSchema: z.ZodMiniType<
  GetServerIdentityImpactRequest$Outbound,
  GetServerIdentityImpactRequest
> = z.pipe(
  z.object({
    userSessionIssuerId: z.string(),
    mcpServerId: z.optional(z.string()),
    change: Change$outboundSchema,
    providerId: z.optional(z.string()),
    clientId: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      userSessionIssuerId: "user_session_issuer_id",
      mcpServerId: "mcp_server_id",
      providerId: "provider_id",
      clientId: "client_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getServerIdentityImpactRequestToJSON(
  getServerIdentityImpactRequest: GetServerIdentityImpactRequest,
): string {
  return JSON.stringify(
    GetServerIdentityImpactRequest$outboundSchema.parse(
      getServerIdentityImpactRequest,
    ),
  );
}
